import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface ReviewLikeRequest {
	reviewId: string;
	goodsCd: string;
}

const key = `useReviewLike`;

const getPath = () => `/bff/portal/reviewLike`;

/** ```
 * 리뷰 좋아요 BFF
 *   `/bff/portal/reviewLike`
 * parameter
 *   `goodsCd` 상품코드
 *   `reviewId` 리뷰ID
 * ```*/
const reviewLikeAsync = (params: ReviewLikeRequest) => useConfigureAxios({url: getPath(), params});

/** ```
 * 리뷰 좋아요 BFF
 *   `/bff/portal/reviewLike`
 * parameter
 *   `goodsCd` 상품코드
 *   `reviewId` 리뷰ID
 * ```*/
const useReviewLike = (params?: ReviewLikeRequest, options?: Partial<UseQueryOptions<Response<null>, Error>>) =>
	useQuery({
		queryKey: [key, getPath()],
		queryFn: () => useConfigureAxios({url: getPath(), params}).then(r => r.data),
		gcTime: Infinity,
		staleTime: Infinity,
		throwOnError: false,
		...options,
	});

export default useReviewLike;
export {getPath, key, reviewLikeAsync};
